import { useMutation } from "@apollo/client";
import { successNotification } from "../../../../result";
import { GET_ATTACHMENTS_STAND } from "../../../../../graphql/query/attachments-gql";

const useMutationStandUpdateFile = (mutation, dataQuery) => {


  const [ _setMutationStandUpdateFile, { loading: loadingMutationStandUpdateFile } ] = useMutation(mutation,
    {
      update(cache, { data }) {
        const {
          attachedUpdate: {
            label,
            message,
            attachment
          }
        } = data;


        cache.writeQuery({
          query: GET_ATTACHMENTS_STAND,
          variables: {
            id: dataQuery.id
          },
          data: {
            attachmentsStand: {
              data: [
                attachment
              ],
              __typename: "AttachmentPaginator"
            }
          }
        })


        successNotification({
          title: label.toUpperCase(),
          description: message
        });
      },
    });


  return {
    _setMutationStandUpdateFile,
    loadingMutationStandUpdateFile,
  }
};

export default useMutationStandUpdateFile;